import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { StaticDocument, UpdateDocumentRequest } from "./types";

import { Data } from "@/shared/types.ts";
import api from "@/shared/api";

const DOCUMENTS_KEY = "static_documents";

// Все языковые версии одного документа.
export function useDocument(slug: string) {
  return useQuery<Data<StaticDocument[]>>({
    queryKey: [DOCUMENTS_KEY, slug],
    queryFn: (ctx) =>
      api
        .get<
          Data<StaticDocument[]>
        >(`/api/v1/admin/documents/${slug}`, { signal: ctx.signal })
        .json(),
    initialData: { data: [], code: 0, description: "", success: true },
  });
}

// Сохранить одну языковую версию.
export function useUpdateDocument() {
  const queryClient = useQueryClient();

  return useMutation<Data<StaticDocument>, Error, UpdateDocumentRequest>({
    mutationFn: ({ slug, locale, content }) =>
      api
        .put(`/api/v1/admin/documents/${slug}`, { json: { locale, content } })
        .json(),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [DOCUMENTS_KEY, variables.slug],
      });
    },
  });
}
